var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreqinLogoExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 540,
    viewBox: "0 0 540 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5474_983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.32892e-05 0.057332H540V540.057H1.32892e-05V0.057332Z",
    fill: "#F1EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000427246 102.792L0.0286129 0L539.785 0.38405L539.781 540.243L437.668 540.46L-0.000427246 102.792Z",
    fill: "#1B0757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.28606 329.608L1.6685e-05 538.18L210.64 539.962L0.28606 329.608Z",
    fill: "#D10077"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5474_983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 540,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreqinLogoExternal);
export default __webpack_public_path__ + "static/media/preqinLogoExternal.40a9a3094f8785efcc753ef98ec566de.svg";
export { ForwardRef as ReactComponent };